import ButtonRemark from './src/main'

ButtonRemark.install = function (Vue) {
    Vue.component(ButtonRemark.name, ButtonRemark)
}

export default ButtonRemark